'use client';
import React, { useState, useEffect } from 'react';

export default function CookieSettingsForm() {
  const [performance, setPerformance] = useState(false);
  const [targeting, setTargeting] = useState(false);
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem('cookieConsent');
    if (saved) {
      const consent = JSON.parse(saved);
      setPerformance(consent.performance || false);
      setTargeting(consent.targeting || false);
    }
    setMounted(true);
  }, []);

  const handleSave = () => {
    localStorage.setItem('cookieConsent', JSON.stringify({
      performance,
      targeting,
    }));
  };

  if (!mounted) {
    return (
      <div>
        <div className="form-check mb-3">
          <input id="consent_performance" type="checkbox" checked={false} disabled readOnly />
          <label className="form-check-label" htmlFor="consent_performance">
            {' '}&nbsp; Performance Cookies
          </label>
        </div>
        <div className="form-check mb-3">
          <input id="consent_targeting" type="checkbox" checked={false} disabled readOnly />
          <label className="form-check-label" htmlFor="consent_targeting">
            {' '}&nbsp;Targeting Cookies
          </label>
        </div>
        <button id="consent_save" className="btn-maroon-cta" type="button" disabled>Save Settings</button>
      </div>
    );
  }

  return (
    <div>
      <div className="form-check mb-3">
        <input
          id="consent_performance"
          type="checkbox"
          checked={performance}
          onChange={(e) => setPerformance(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="consent_performance">
          {' '}&nbsp; Performance Cookies
        </label>
      </div>

      <h2>Advertising (Targeting) Cookies</h2>
      <p>These cookies are used to make advertising messages more relevant to you and your interests. They also perform functions like preventing the same ad from continuously reappearing, ensuring that ads are properly displayed, and in some cases selecting advertisements that are based on your interests. For further information, see the section of the Cookie Statement entitled "Targeted online advertising". More info can be found in our privacy policy</p>
      <div className="form-check mb-3">
        <input
          id="consent_targeting"
          type="checkbox"
          checked={targeting}
          onChange={(e) => setTargeting(e.target.checked)}
        />
        <label className="form-check-label" htmlFor="consent_targeting">
          {' '}&nbsp;Targeting Cookies
        </label>
      </div>

      <button id="consent_save" className="btn-maroon-cta" type="button" onClick={handleSave}>Save Settings</button>
    </div>
  );
}
